import { useEffect } from 'react';
import { clearLoginTradeBypass } from '../helpers/loginTradeBypass';

const RedirectPage = () => {
  useEffect(() => {
    clearLoginTradeBypass();
    window.location.replace(process.env.REACT_APP_NOMYX_AUTH_URL);
  }, []);
  return null;
};

export default RedirectPage;
